import React from 'react';
import Card from 'react-bootstrap/Card';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

//Generic
import {
    CompetitorBlockNoData as CompetitorBlockNoDataGeneric, CompetitorBlock as CompetitorBlockGeneric,
} from "components/sports/glo/brackets/generic";
import {
    Footer as FooterGeneric, Header as HeaderGeneric, BodyComponent as BodyComponentGeneric
} from "components/sports/glo/todayMatches/generic";

//Sports
import { CompetitorBlock as CompetitorBlockTte, Footer as FooterTte, Header as HeaderTte } from "components/sports/glo/todayMatches/tte";
import { Footer as FooterFen, CompetitorBlock as CompetitorBlockFen, } from "components/sports/glo/todayMatches/fen";
import { CompetitorBlock as CompetitorBlockTen, Footer as FooterTen, Header as HeaderTen, BodyComponent as BodyComponentTen } from "components/sports/glo/todayMatches/ten";
import { Footer as FooterJud, Header as HeaderJud, BodyComponent as BodyComponentJud } from "components/sports/glo/todayMatches/jud";
import { Header as HeaderWre, BodyComponent as BodyComponentWre } from "components/sports/glo/todayMatches/wre";



const getCompetitorType = (discipline) => {
    switch (discipline) {
        case 'BKB':
        case 'JUD':
            return CompetitorBlockGeneric
        case 'TEN':
        case 'WTE':
            return CompetitorBlockTen
        case 'TTE':
            return CompetitorBlockTte
        case 'FEN':
            return CompetitorBlockFen
        default:
            return CompetitorBlockGeneric
    }
}

const getCompetitorNoDataType = (discipline) => {
    switch (discipline) {
        case 'BKB':
        case 'FEN':
        case 'JUD':
            return CompetitorBlockNoDataGeneric
        default:
            return CompetitorBlockNoDataGeneric
    }
}

const getFooter = (discipline) => {
    switch (discipline) {
        case 'JUD':
            return FooterJud
        case 'BKB':
        case 'TTE':
        case 'WRE':
            return FooterTte
        case 'FEN':
            return FooterFen
        case 'TEN':
        case 'WTE':
            return FooterTen
        default:
            return FooterGeneric
    }
}

const getHeader = (discipline) => {
    switch (discipline) {
        case 'JUD':
            return HeaderJud
        case 'WRE':
            return HeaderWre
        case 'BKB':
        case 'FEN':
        case 'TTE':
            return HeaderTte
        case 'TEN':
        case 'WTE':
            return HeaderTen
        default:
            return HeaderGeneric
    }
}

const getBodyComponent = (discipline) => {
    switch (discipline) {
        case 'JUD':
            return BodyComponentJud
        case 'WRE':
            return BodyComponentWre
        case 'TEN':
        case 'WTE':
            return BodyComponentTen
        default:
            return BodyComponentGeneric
    }

}

const ScoresLiveCard = ({ data }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    const CompetitorComponent = getCompetitorType(mirs_discipline)
    const CompetitorNoDataComponent = getCompetitorNoDataType(mirs_discipline)
    const FooterComponent = getFooter(mirs_discipline)
    const HeaderComponent = getHeader(mirs_discipline)
    const BodyComponent = getBodyComponent(mirs_discipline)
    const period = data?.result?.extendedInfos?.find(i => i?.ei_code === 'LAST_COMP')?.ei_pos;

    return (<>
        <Card className={mirs_discipline === 'TTE' || mirs_discipline === 'WRE' ? 'scores-today-match-tte' : 'scores-today-match'} >
            <Card.Header className='d-flex'>
                <HeaderComponent data={data} />
            </Card.Header>
            <Card.Body className="shadow-scrollbox">
                <BodyComponent data={data} competitorComponent={CompetitorComponent} competitorNoDataComponent={CompetitorNoDataComponent} />
            </Card.Body>
            <Card.Footer>
                <FooterComponent data={data} period={period} mirs_discipline={mirs_discipline} />
            </Card.Footer>
        </Card>
    </>
    );
}

export default ScoresLiveCard;